import React, { useMemo } from 'react'
import { pathStrOr, projectAs } from 'utils/fp'
import MultiDropdown from 'core/elements/dropdown/MultiDropdown'
import useListAction from 'core/hooks/useListAction'
import useSelectorWithParams from 'core/hooks/useSelectorWithParams'
import { listCloudProviderRegionDetails } from 'app/plugins/infrastructure/components/cloudProviders/new-actions'
import { cloudProviderRegionDetailsSelector } from 'app/plugins/infrastructure/components/cloudProviders/selectors'
import DropdownField from 'core/components/validatedForm/DropdownField'

interface Props {
  id: string
  label: string
  cloudProviderId: string
  cloudProviderRegionId: string
  clusterAzs?: any
  values: any
  onChange: any
  required?: boolean
  disabled?: boolean
  showOnlyClusterAzs?: boolean
}

const CapiAwsAvailiabilityZoneChooser = ({
  cloudProviderId,
  cloudProviderRegionId,
  clusterAzs,
  onChange,
  id,
  label,
  showOnlyClusterAzs,
  ...rest
}: Props) => {
  const { loading: loadingCloudProviderRegionDetails } = useListAction(
    listCloudProviderRegionDetails,
    {
      params: { cloudProviderId, cloudProviderRegionId },
    },
  )

  const regionDetails = useSelectorWithParams(cloudProviderRegionDetailsSelector, {
    cloudProviderId,
    cloudProviderRegionId,
  })

  const regions = useMemo(() => {
    const azs = pathStrOr([], '0.azs', regionDetails)
    return projectAs({ label: 'ZoneName', value: 'ZoneName' }, azs)
  }, [regionDetails])

  const clusterAzItems = useMemo(() => {
    return clusterAzs.map((az) => ({ label: az, value: az }))
  }, [clusterAzs])

  return (
    <MultiDropdown
      id={id}
      name={id}
      label={label}
      className="validatedFormInput"
      items={showOnlyClusterAzs ? clusterAzItems : regions}
      onChange={onChange}
      loading={loadingCloudProviderRegionDetails}
      enableSearch
      {...rest}
    />
  )
}

export default CapiAwsAvailiabilityZoneChooser
